export type ChecklistKind = "upload" | "answer" | "action";

export interface ChecklistItem {
  id: string;
  label: string;
  kind: ChecklistKind;
  hint?: string;
}

const RULES: { id: string; test: RegExp; item: Omit<ChecklistItem, "id"> }[] = [
  { id: "ss-card", test: /\bss(n)?\s*card|social security card/i, item: { label: "Social Security card", kind: "upload" } },
  { id: "ein-letter", test: /\bss[\s-]?4\b|ein letter|irs ein|cp\s?575/i, item: { label: "IRS EIN letter (SS-4)", kind: "upload" } },
  { id: "utility-bill", test: /utility bill/i, item: { label: "Utility bill (owner's home)", kind: "upload" } },
  { id: "drivers-license", test: /driver'?s?\s*licen[cs]e|\bdl\b|photo id/i, item: { label: "Driver's license", kind: "upload" } },
  { id: "business-license", test: /business licen[cs]e|seller'?s permit|proof of business|gov'?t issued proof/i, item: { label: "Business license", kind: "upload" } },
  { id: "financials", test: /financials?\b|financial statements?|bank statements?|tax returns?/i, item: { label: "Financial statements", kind: "upload" } },
  { id: "contract", test: /contract/i, item: { label: "Customer contract or invoice", kind: "upload" } },
  { id: "page-one", test: /(corrected|updated)\s*(pg|page)\s*1/i, item: { label: "Corrected page 1", kind: "upload" } },
  { id: "unfreeze", test: /unfreeze|lift (the )?freeze|credit freeze|freeze on transunion/i, item: { label: "Owner unfroze TransUnion", kind: "action" } },
  { id: "call-times", test: /(times?|when|dates?).{0,90}(reach|reached|call)/i, item: { label: "Best time to call the owner?", kind: "answer", hint: "9 AM–4 PM ET" } },
  { id: "explain", test: /\bwhy\b|explain|clarify|describe/i, item: { label: "Answer for underwriting", kind: "answer" } },
];

export function checklistFor(request: string): ChecklistItem[] {
  return RULES.filter((r) => r.test.test(request)).map((r) => ({ id: r.id, ...r.item }));
}

export interface ChecklistEntry {
  files: File[];
  answer: string;
  done: boolean;
}

export function isComplete(item: ChecklistItem, entry: ChecklistEntry | undefined) {
  if (!entry) return false;
  if (item.kind === "upload") return entry.files.length > 0;
  if (item.kind === "answer") return entry.answer.trim().length > 0;
  return entry.done;
}

export function checklistMessage(business: string, items: ChecklistItem[], entries: Record<string, ChecklistEntry>) {
  const lines = items.map((item) => {
    const entry = entries[item.id];
    if (item.kind === "upload") return `- ${item.label} – attached`;
    if (item.kind === "answer") return `- ${item.label.replace(/\?$/, "")}: ${entry?.answer.trim() ?? ""}`;
    return `- ${item.label}`;
  });
  return [`Please see the requested items for ${business}:`, "", ...lines].join("\n");
}
